<template>
  <div>
    <div class="business-state">
      <div class="business-state-icon" />
      <van-cell>
        <template v-if="progessName" #title>
          <span class="custom-title">目前状态：</span>
          <span :class="progessStatus === 'nh_02_00_st' ? 'custom-now-name-red' : (progessStatus === 'nh_00_01_st' ? 'custom-now-name-red' : ( progessStatus === 'nh_01_00_st' ? 'custom-now-name-green' :  ( progessStatus === 'nh_03_00_st' ? 'custom-now-name-gray' : 'custom-now-name'))) ">{{ progessName }}</span>
        </template>
      </van-cell>
      <van-cell v-if="progessStatusName" is-link center @click="BusinessStep">
        <template #title>
          <span class="custom-title">最新操作：</span>
          <span class="custom-new-name">{{ progessStatusName }}</span>
        </template>
        <template #label>
          <span class="custom-label">{{ updatedTime }}</span>
        </template>
      </van-cell>
      <!-- <van-cell v-if="hasBz" is-link center @click="BzBusinessStep">
        <template #title>
          <span class="custom-title">当前报装流程：</span>
          <span class="custom-new-name">{{ progessStatusName }}</span>
        </template>
        <template #label>
          <span class="custom-label">{{ updatedTime }}</span>
        </template>
      </van-cell> -->
      <van-cell v-if="hasBz" is-link center @click="showFileList">
        <template #title>
          <span class="custom-title">报装流程附件列表</span>
        </template>
      </van-cell>
    </div>
    <!-- nh_00_01_st 拒绝 -->
    <div v-if="progessRemark && progessStatus === 'nh_02_00_st'" class="business-describe">
      <p>尊敬的客户，您提交的以下信息有误，已被拒绝!</p>
      <p>{{ progessRemark }}</p>
    </div>
    <!-- nh_00_01_st 待补缴资料 -->
    <div v-else-if="progessRemark && progessStatus === 'nh_00_01_st'" class="business-describe">
      <p>尊敬的客户，您提交的以下信息有误，请重新提交!</p>
      <p>{{ progessRemark }}</p>
    </div>
    <van-dialog v-model="showDialog" title="请选择" show-cancel-button confirmButtonText="是" cancelButtonText="否" :beforeClose="beforeClose">
      <div class="dialog-content">
        <div class="title">
          <p>尊敬的用户，根据相关文件规定，您本次申请的报装费用为人民币：<span>{{ paymentAmount }}</span> 元，您可通过银行转账形式进行缴费。</p>
        </div>
        <div class="content">
          <p>账户名称：重庆丰都水务集团有限公司</p>
          <p>账号 ：50001293600050007616</p>
          <p>开户行：建行丰都支行</p>
        </div>
        <div class="action-text">
          是否已完成缴费？
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { formatTime } from '@/utils/tools';
import { mapState } from 'vuex';
import { Toast } from 'vant';
import { updatePaymentStatus } from "@/api/business";
export default {
  name: 'BusinessStatus',
  props: {
    statusInfor: {
      type: Object,
      default: () => {
        return {};
      }
    },
    busHandlingId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      status: null,
      progessName: null,
      progessStatus: null,
      progessStatusCode: null,
      progessStatusName: null,
      updatedTime: null,
      progessRemark: null,
      processingDays: null,
      showDialog: false,
      paymentAmount: 0
    };
  },
  computed:{
    ...mapState('user', {
      businessNews: (state) => state.businessNews
    }),
    hasBz(){
      return this.businessNews && this.businessNews.businessCode === '0035';
    }
  },
  watch: {
    statusInfor: {
      handler() {
        if (this.statusInfor) {
          this.conversionNews(this.statusInfor);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    /* 解析业务办理信息数据 */
    conversionNews(data) {
      this.stateBoolean = data.stateBoolean;
      this.status = data.status !== undefined ? data.status : null;
      this.progessName = data.progessName !== undefined ? data.progessName : null;
      this.progessStatus = data.progessStatus !== undefined ? data.progessStatus : null;
      this.processingDays = data.processingDays !== undefined ? data.processingDays : null;
      this.progessStatusCode = data.progessStatusCode !== undefined ? data.progessStatusCode : null;
      this.progessStatusName = data.progessStatusName !== undefined ? data.progessStatusName : null;
      this.updatedTime =
        data.progessCreateTime !== undefined ? formatTime(data.progessCreateTime) : null;
      this.progessRemark = data.progessRemark !== undefined ? data.progessRemark : null;
      this.paymentAmount = data.paymentAmount !== undefined ? data.paymentAmount : 0;
      // if (this.progessStatusName === '财务审批') {
      //   this.showDialog = true;
      // }
    },
    /* 步骤信息跳转 */
    BusinessStep() {
      if(this.hasBz){
        this.BzBusinessStep();
        return;
      }
      if (this.busHandlingId) {
        this.$router.push({ path: '/Business/BusinessStep' });
      }
    },
    BzBusinessStep() {
      if (this.busHandlingId) {
        this.$router.push({ path: '/Business/BzBusinessStep' });
      }
    },
    showFileList(){
      this.$router.push({ path: '/Business/BzFileList' });
    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        this.confirm().then((res)=>{
          if (res) {
            done();
          } else {
            done(false);
          }
        });
      } else {
        done();
      }
    },
    async confirm() {
      let data = false;
      try {
        const { status } = await updatePaymentStatus(this.busHandlingId);
        if (status === 'complete') {
          data = true;
        }
      } catch (error) {
        console.log(error);
      }
      return data;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-dialog__header{
  padding-top: 16px;
}
.dialog-content{
  padding: 0 12px;

  p {
    margin: 0;
  }

  .title {
    margin-top: 12px;
    p span {
      color: #f64357;
    }
  }

  .content{
    margin: 10px 0;
    font-size: 14px;
    p {
      margin: 4px 0;
    }
  }

  .action-text {
    font-size: 14px;
    color: #f64357;
    margin-bottom: 10px;
  }
}
.business-state {
  margin: 16px;
  overflow: hidden;
  background: #ffffff;
  border-radius: 8px;
  position: relative;

  .business-state-icon {
    width: 4px;
    height: 20px;
    background: #4380e4;
    position: absolute;
    top: 10px;
    z-index: 99;
  }

  .custom-title {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
  }

  .custom-label {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
  }

  .custom-now-name {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #4380e4;
  }

  .custom-now-name-red {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #ff5858;
  }

  .custom-now-name-gray {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333;
  }

  .custom-now-name-green {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #25b1bf;
  }

  .custom-new-name {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
  }

  /* 审核中 */
  .underReview {
    color: #4380e4;
  }

  /* 补交资料 */
  .makeUp {
    color: #f64357;
  }

  /* 处理中 */
  /* 办结 */
  .Finish {
    color: #25b1bf;
  }

  /* 拒绝 */
  .refuse {
    color: #f64357;
  }

  /* 取消 */
  .cancel {
    color: #a2b0c6;
  }
}
.business-describe {
  margin: 16px;
  overflow: hidden;
  background: #ffecde;
  border-radius: 8px;
  padding: 10px 16px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #fc882c;
  line-height: 20px;

  p {
    margin: 0;
  }
}
</style>
